// src/pages/connect/ExcelUpload.js
import React, { useState } from "react";
import {
  Card,
  Button,
  Form,
  Alert,
  Modal,
  Table,
  Spinner,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faPlug } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const ExcelUpload = () => {
  const [uploaded, setUploaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const API_BASE = `https://api-dashboard.nordmann-inkasso.de
/api/excel`; // backend endpoint

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setUploaded(false);
    setInvoices([]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return;

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.post(`${API_BASE}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        setUploaded(true);
        setInvoices(res.data.invoices || []); // backend should return parsed invoices
      }
    } catch (err) {
      console.error("Error uploading Excel:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewInvoices = () => {
    setShowModal(true);
  };

  return (
    <div className="p-4">
      <h3 className="mb-4">
        <FontAwesomeIcon icon={faPlug} className="me-2" />
        Upload Excel/CSV
      </h3>

      <Card className="shadow-sm">
        <Card.Body>
          <FontAwesomeIcon
            icon={faUpload}
            size="2x"
            className="mb-3 text-success"
          />
          <Card.Title>Excel / CSV Upload</Card.Title>
          <Card.Text>
            Upload your accounting data manually using Excel or CSV files.
          </Card.Text>

          <Form onSubmit={handleUpload}>
            <Form.Group controlId="formFile" className="mb-2">
              <Form.Control
                type="file"
                accept=".csv, .xls, .xlsx"
                required
                onChange={handleFileChange}
              />
            </Form.Group>
            {uploaded ? (
              <>
                <Alert variant="success" className="mt-2">
                  ✅ File uploaded successfully!
                </Alert>
                <Button
                  variant="secondary"
                  className="mt-2"
                  onClick={handleViewInvoices}
                >
                  View Invoices
                </Button>
              </>
            ) : (
              <Button type="submit" variant="success" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : "Upload"}
              </Button>
            )}
          </Form>
        </Card.Body>
      </Card>

      {/* Modal for invoices */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Uploaded Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {invoices.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Invoice ID</th>
                  <th>Customer</th>
                  <th>Amount</th>
                  <th>Due Date</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv, idx) => (
                  <tr key={idx}>
                    <td>{inv.invoiceId || "-"}</td>
                    <td>{inv.customerName || "-"}</td>
                    <td>{inv.amount || "-"}</td>
                    <td>
                      {inv.dueDate
                        ? new Date(inv.dueDate).toLocaleDateString()
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>No invoices found in uploaded file.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ExcelUpload;
